// userService.js
import { get, post, patch } from './common';


export const createCall  = (data) => {
    return post('calls/create-call', data);
};

export const joinCall  = (data) => {
    return post('calls/join-call', data);
};

export const endCall  = (data) => {
    return post('calls/end-call', data);
};

export const getRecordingStatus  = (callId) => {
    return get('calls/recording-status/'+callId);
};


